import gen from '../gen'
import auth from '../auth/auth'
import googleCloudVisionAPI from './googleCloudVisionAPI'
import imaggaAPI from './imaggaAPI'
var ls = require('local-storage');
import uploadImage_2 from './uploadImage_2'
import router from '../../../router'
import uploadImage_4 from './uploadImage_4'
import uploadImage_3 from './uploadImage_3'
import {
  uploadImage,
  upload_2
} from '../../../api'
import axios from 'axios'

const state = {
  keywords_uploadImage: [],
  selectedKeywords_uploadImage: [],
  showShareButton: false
}

const getters = {
  selectedKeywords_uploadImage: state => state.selectedKeywords_uploadImage
}

const mutations = {
  //SHARE PHOTO
  sharePhoto_uploadImage_5(state2, payload) {
    state.showShareButton = true
    //
    //if(payload.keywords.length != 0){ //not empty
    //if(payload.locationVisible.length != 0) {
    //proceed
    //
    //axios
    axios.get(uploadImage, {
      params: {
        isCron: false,
        anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
        caption: payload.caption, //
        publicId: payload.publicId,
        //
        createdAt: payload.createdAt, //
        //
        emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
        hasGeohash: payload.hasGeohash, //
        keywords: JSON.stringify(payload.keywords),
        locationVisible: JSON.stringify(payload.locationVisible), //
        resourceType: payload.resourceType, //
        //
        shareSpotLocation: payload.shareSpotLocation, //
        //
        spotType: JSON.stringify(payload.spotType),
        url: payload.url, //
        //
        //user depended //added later, not coming from dom/link
        uid: auth.state.user.uid,
        uploader: 'user',
        email: auth.state.user.email,
        displayName: auth.state.user.displayName,
        displayPic: auth.state.user.photoURL,
        myPhoto: true,
        photoSourceLink: '',
        licenseType: '',
        pic_desc: payload.travelInfo,
        mon: payload._mon2,
        dur: payload._dur2
      }
    }).then((response) => {
      state.showShareButton = false
      router.push('/?loc=Worldwide')
      // router.push(`/profile?selected_tab=shared&profile_id=${auth.state.user.uid}&uploader=user`)
      if (payload.resourceType === 'video') {
        gen.mutations.snackbar_alert(state, {
          msg: 'Video uploaded !'
        })
      }
      else {
        gen.mutations.snackbar_alert(state, {
          msg: 'Image uploaded !'
        })
      }
      // empty variables
      uploadImage_2.state.caption_uploadImage = ' '
      state.selectedKeywords_uploadImage = []
      uploadImage_4.state.selectedSpotType_uploadImage = []
      uploadImage_2.state.selectedemotionalAppeal_uploadImage = []
    }).catch((e) => {
      state.showShareButton = false
      // console.log("[exception][uploadImage_5]", e)
    })
    /* gen
       .actions
       .axiosGetReq(state, {
         url: 'https://us-central1-travel-app-admin.cloudfunctions.net/uploadImage',
         obj: {
           anyoneCanVisitThisSpot: payload.anyoneCanVisitThisSpot,
           caption: payload.caption, //
           publicId: payload.publicId,
           //
           createdAt: payload.createdAt, //
           //
           emotionalAppeal: JSON.stringify(payload.emotionalAppeal),
           hasGeohash: payload.hasGeohash, //
           keywords: JSON.stringify(payload.keywords),
           locationVisible: JSON.stringify(payload.locationVisible), //
           resourceType: payload.resourceType, //
           //
           shareSpotLocation: payload.shareSpotLocation, //
           //
           spotType: JSON.stringify(payload.spotType),
           url: payload.url, //
           //
           //user depended //added later, not coming from dom/link
           uid: auth.state.user.uid,
           uploader: 'user',
           email: auth.state.user.email,
           displayName: auth.state.user.displayName,
           displayPic: auth.state.user.photoURL
         }
       }).then((response) => {
         console.log(response.data)
         state.showShareButton = false
         router.push('/')
         gen.mutations.snackbar_alert(state, {
           msg: 'Image uploaded !'
         })
         // empty variables
         uploadImage_2.state.caption_uploadImage = ''
         state.selectedKeywords_uploadImage = []
         uploadImage_4.state.selectedSpotType_uploadImage = []
         uploadImage_2.state.selectedemotionalAppeal_uploadImage = []
       }).catch((e) => {
         state.showShareButton = false
         console.log("[exception][uploadImage_5]", e)
       })
     //
   //}else{
     //gen.mutations.snackbar_alert(state, {
       //msg: 'Please select at least one tag of location visible related to the image'
     //})
   //}
 //}else{ //error
   //gen.mutations.snackbar_alert(state, {
     //msg: 'Please select at least one keyword related to the image'
   //}) */
    //}
    //
  },
  //****** GET SUGGESTIONS FROM LOCAL STORAGE ******/
  getGoogleVisionAPISuggestionFromLocalStorage(state2) { // landmark & keywords // google vision api + imagga
    //
    googleCloudVisionAPI.state.googleCloudVisionAPI_landmarkSuggestion =
      JSON.parse(ls.get('googleVisionAPI_landmarkSuggestion'))
    //
    uploadImage_2.state.locationVisible_uploadImage =
      googleCloudVisionAPI.state.googleCloudVisionAPI_landmarkSuggestion
    //
    googleCloudVisionAPI.state.googleCloudVisionAPI_labelSuggestion =
      JSON.parse(ls.get('googleVisionAPI_labelSuggestion'))
    //
    state.keywords_uploadImage =
      state.keywords_uploadImage.concat(googleCloudVisionAPI.state.googleCloudVisionAPI_labelSuggestion) //dropdown
    //
    imaggaAPI.state.imaggaSuggestion =
      gen.actions.arrayUnique(imaggaAPI.state.imaggaSuggestion.concat(googleCloudVisionAPI.state.googleCloudVisionAPI_labelSuggestion)) //chips

    //imagga
    state.keywords_uploadImage = JSON.parse(ls.get('imaggaSuggestions'))
    //
    imaggaAPI.state.imaggaSuggestion = gen.actions.arrayUnique(JSON.parse(ls.get('imaggaSuggestions')))
  },
  //****** GET SUGGESTIONS FROM LOCAL STORAGE ENDS ******/
  //
  //****** UI LOGICS - SELECT/DESELECT ******/
  selectThisImaggaSuggestion(state2, payload) { //ui logic //select deselect
    //
    let tag = payload.tag
    //
    state.selectedKeywords_uploadImage.push(tag)
  },
  //
  deselectThisImaggaSuggestion(state, payload) { //ui logic //select deselect
    //
    let tag = payload.tag
    //
    let keyOfSelectedArr = state.selectedKeywords_uploadImage.indexOf(tag) //key of selected array
    state.selectedKeywords_uploadImage.splice(keyOfSelectedArr, 1)
    //
  },
  //
  selectThisGoogleVisionAPI_landmark(state2, payload) {  //ui logic //select deselect
    //
    let tag = payload.tag
    //
    uploadImage_2.state.selectedLocationVisible_uploadImage.push(tag)
  },
  //
  deselectThisGoogleVisionAPI_landmark(state, payload) {   //ui logic //select deselect
    //
    let tag = payload.tag
    //
    let keyOfSelectedArr = uploadImage_2.state.selectedLocationVisible_uploadImage.indexOf(tag) //key of selected array
    uploadImage_2.state.selectedLocationVisible_uploadImage.splice(keyOfSelectedArr, 1)
    //
  }
  /**** UI LOGICS - SELECT/DESELECT ENDS ****/
}

const actions = {
  //
  // new share image
  async SHARE_UPLOAD_IMAGE({ commit }, payload) {
    try {
      let { data } = await axios.get(upload_2, {
        params: payload
      })
      uploadImage_4.state.anyoneCanVisitThisSpot_uploadImage = []
      uploadImage_3.state.geoLocIsAvailable_uploadImage_3 = false
      uploadImage_2.state.caption_uploadImage = ' '
      uploadImage_3.state.travelInfo = ''
      uploadImage_2.state.selectedemotionalAppeal_uploadImage = []
      state.selectedKeywords_uploadImage = []
      uploadImage_4.state.selectedSpotType_uploadImage = []
      uploadImage_3.state.geohashVal = ''
      // router.push('/')
      setTimeout(() => {
        router.push({
          path: `/id/${payload.photoId}?inapp=true`
        });
      }, 1000)

      if (payload.resourceType == 'video') {
        gen.mutations.snackbar_alert(state, {
          msg: 'Video uploaded !'
        })
      }
      else {
        gen.mutations.snackbar_alert(state, {
          msg: 'Image uploaded !'
        })
      }
    }
    catch (e) {
      console.log(e)
    }
  }
  //
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/uploadImage_5.js